/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useContext, useEffect, useState } from 'react'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'

import { dateTimeCol, numCol, strCol } from '@integec/grid-tools/lib/cols'
import {
  getSolarLsbpMeasurment,
  importSolarLsbpMeasurment,
} from './../solarapi'

import R from 'ramda'
import { Button, DatePicker, message, Select } from 'antd'

import moment from 'moment'
import { DatePickerContext, ErrorContext } from 'context'
import { getSolarPlant } from 'api/pgads'

const title = 'Solar SF Measurment'

const SolarLSBPMeasurment = ({ apiTargetInfo }) => {
  const { setError } = useContext(ErrorContext)
  const [date, setDate] = useState(
    moment()
      .subtract(1, 'month')
      .startOf('month')
  )
  const [plantMap, setPlantMap] = useState([])
  useEffect(
    _ => {
      getSolarPlant(apiTargetInfo).fork(setError, data => {
        const pm = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({ [d.plantId]: d.plantName }))
        )
        setPlantMap(pm)
      })
    },
    [apiTargetInfo, setError]
  )

  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )
  const [selPlant, setSelPlant] = useState([])

  const screenCriteria = (s, p, u, onChange) => {
    return (
      <React.Fragment>
        <DatePicker
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDateRangePicker[0]}
          onChange={d => {
            setSelectedDateRagePicker([d, d.clone().add(1, 'd')])
            onChange()
          }}
        />
        <Select
          id="plant"
          showSearch
          style={{ width: 250, marginLeft: 10 }}
          value={selPlant}
          onChange={val => {
            setSelPlant(val)
            onChange()
          }}
          // mode="multiple"
          placeholder="Select Plant"
        >
          {R.compose(
            R.sortBy(R.prop('value')),
            R.map(([k, v]) => ({ id: k, value: v })),
            R.toPairs
          )(plantMap).map(k => (
            <Select.Option value={k.id} key={k.id}>
              {/* {`${k}-${keymap[k]}`} */}
              {`${k.id} - ${k.value}`}
            </Select.Option>
          ))}
        </Select>
      </React.Fragment>
    )
  }
  const [selPlantImport, setSelPlantImport] = useState([])
  const extraCriteriaAfterButton = () => {
    return (
      <div style={{ border: '1px solid gray', padding: 5 }}>
        <Button
          // loading={importing}
          onClick={importData}
          style={{ marginLeft: '10px' }}
          type="danger"
          icon="thunderbolt"
        >
          Import Data
        </Button>
        <DatePicker.MonthPicker
          style={{ marginLeft: '15px' }}
          allowClear={false}
          format="MMM YYYY"
          value={date}
          onChange={d => {
            setDate(d)
          }}
        />
        <Select
          id="plant"
          showSearch
          style={{ width: 250, marginLeft: 10 }}
          value={selPlantImport}
          onChange={val => {
            setSelPlantImport(val)
          }}
          // mode="multiple"
          placeholder="Select Plant"
        >
          <Select.Option value="ALL">ALL</Select.Option>
          {R.compose(
            R.sortBy(R.prop('value')),
            R.map(([k, v]) => ({ id: k, value: v })),
            R.toPairs
          )(plantMap).map(k => (
            <Select.Option value={k.id} key={k.id}>
              {/* {`${k}-${keymap[k]}`} */}
              {`${k.id} - ${k.value}`}
            </Select.Option>
          ))}
        </Select>
      </div>
    )
  }

  const importData = _ => {
    if (selPlantImport.length <= 0) {
      message.warn('Please, Select Plant for import.')
      return
    }
    importSolarLsbpMeasurment(apiTargetInfo)(withCriteria()).fork(setError, _ =>
      message.info('Data started importing, Please check data after sometime.')
    )
  }

  const withCriteria = () => {
    return {
      year: date.format('YYYY'),
      month: date.format('MM'),
      startDate: selectedDateRangePicker[0].format('YYYY-MM-DD'),
      endDate: selectedDateRangePicker[1].format('YYYY-MM-DD'),
      selPlant,
      selPlantImport: !selPlantImport.includes('ALL')
        ? selPlantImport
        : Object.keys(plantMap),
    }
  }
  const beforeRetrieveValidation = _ => {
    if (selPlant.length <= 0) {
      message.warn('Please,Select Plant')
      return false
    }
    return true
  }

  return (
    <CommonScreen
      beforeRetrieveValidation={beforeRetrieveValidation}
      // extraCriteria={extraCriteria}
      autoRetrieve={false}
      screenCriteria={screenCriteria}
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      withCriteria={withCriteria}
      title={title}
      allowInsert={false}
      withoutModify
      withDelete={false}
      header={SolarLsbpSfMeasurmentsHeaders}
      saveTask={_ => _}
      retrieveTask={getSolarLsbpMeasurment}
      deleteTask={_ => _}
      widthOffset={50}
      insertComp={false}
      insertCompHeight={50}
      onInsertEvent={_ => _}
      autoFixColByKey={false}
      headerRowHeight={30}
      //   totalWidth={150 + 650 + 700 + 150}
      sortOptions={SolarLsbpSfMeasurmentsHeaders}
      defaultInsertData={{ accessRight: 'R' }}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(SolarLSBPMeasurment)

const SolarLsbpSfMeasurmentsHeaders = [
  strCol({
    ident: 'siteName',
    display: 'Site Name',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
  }),
  strCol({
    ident: 'siteReference',
    display: 'Site Reference',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'nercId',
    display: 'NERC Id',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'deviceName',
    display: 'Device Name',
    isKey: true,
    sortOrder: 'asc',
    width: 250,
  }),
  strCol({
    ident: 'measurementApcode',
    display: 'Measurement Apcode',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
  }),
  strCol({
    ident: 'measurementName',
    display: 'Measurement Name',
    isFiltered: true,
    sortOrder: 'asc',
    width: 250,
  }),
  dateTimeCol({
    ident: 'localTime',
    display: 'Local Time',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
  }),
  dateTimeCol({
    ident: 'utcTime',
    display: 'UTC Time',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'measurementValue',
    display: 'Measurement Value',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
  }),
  strCol({
    ident: 'timeInterval',
    display: 'Time Interval',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
  }),
  dateTimeCol({
    ident: 'createdTime',
    display: 'Created Time',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
  }),
  dateTimeCol({
    ident: 'updatedTime',
    display: 'Updated Time',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
  }),
  strCol({
    ident: 'timeInterval',
    display: 'Time Interval',
    isFiltered: true,
    sortOrder: 'asc',
  }),
]
